
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from "next/head";
import HeaderSearch from "../../component/common/HeaderSearch";
import { initializeApollo } from "../../apollo-client";
import { useRouter } from "next/router";
import SearchIcon from "@heroicons/react/solid/SearchCircleIcon";
import NoResultListingSearch from "../../component/common/NoResultListingSearch";
import CustomedPagination from "../../component/common/Pagination";
import ListingItem from "../../component/common/ListingItem";
import { gql } from "@apollo/client";
import { LISTING_FRAGMENT } from "../../action/listingRecommendation";
import { useEffect, useRef, useState } from "react";
import { useStateContext } from "../../context";
import SearchListingBar from "../../component/common/SearchListingBar";
import { Dropdown, Offcanvas } from "react-bootstrap";
import ListingFilter from "../../component/ListingAction/ListingFilter";
import { TRACK_LISTING_VIEW } from "../../utils/trackEvent";
import useTranslation from "next-translate/useTranslation";
export default function SearchPage(props) {
    const { t } = useTranslation("listing");
    const router = useRouter();
    const { page, search, sortBy: sort, asc } = router.query;
    const inputEl = useRef(null);
    const { data: { listings: { request_id, total_page, nodes, total, facets }, }, error, } = props;
    const sortOptions = [
        {
            id: 1,
            label: t("relevance"),
            sort: 1,
            asc: false
        },
        {
            id: 2,
            label: t("last updated"),
            sort: 2,
            asc: false
        },
        {
            id: 3,
            label: t("highest price"),
            sort: 3,
            asc: false
        },
        {
            id: 4,
            label: t("lowest price"),
            sort: 3,
            asc: true
        },
    ];
    const [state, setState] = useStateContext();
    const clickCount = state.countView;
    const [show, setShow] = useState(false);
    const [sortBy, setSortBy] = useState(1);
    useEffect(() => {
        const foundOption = sortOptions.find((option) => option.sort === parseInt(sort) && option.asc === (asc === "true"));
        setSortBy(foundOption?.id || 1);
    }, [router.query]);
    const handleShow = () => setShow(!show);
    const handleOnListingClick = (listingDetail) => {
        TRACK_LISTING_VIEW(`${listingDetail.id}`, {
            from: "listing-view",
            area: listingDetail.area.area_name,
            category: listingDetail.category,
            district: listingDetail.district.district_name,
            listingFor: listingDetail.listingFor,
            state: listingDetail.state.state_name
        });
    };
    const onPaginationLinkClick = (currentPage) => {
        router.query.page = currentPage;
        var str = "";
        for (var key in router.query) {
            if (key === "slug") {
                continue;
            }
            if (str != "") {
                str += "&";
            }
            str += key + "=" + encodeURIComponent(router.query[key]);
        }
        router.push(`/${router.query.slug}?${str}`);
    };
    const handleSort = (choosen) => {
        const { sort, asc, id } = choosen;
        router.query.sortBy = sort;
        router.query.asc = asc;
        setSortBy(id);
        var str = "";
        for (var key in router.query) {
            if (str != "") {
                str += "&";
            }
            str += key + "=" + encodeURIComponent(router.query[key]);
        }
        router.push(`/${router.query.slug}?${str}`);
    };
    return (<div>
      <Head>
        <title className="text-capitalize">
          {router.query?.slug?.split("-").join(" ")} | Rumahdewi.com
        </title>
        <meta name="description" content={`${router.query?.slug
            ?.split("-")
            .join(" ")} hanya di Rumahdewi.com. Temukan listing ${router.query?.slug
            ?.split("-")
            .slice(1)
            .join(" ")} harga murah dengan lokasi strategis dan banyak pilihan`}/>
        <link rel="icon" href="/favicon.ico"/>
      </Head>

      <HeaderSearch />

      <div className="container bg-white py-3">
        <div className="row">
          <div className="col-12 mb-3">
            <div className="d-flex gap-2">
              <h5 className="fw-normal d-flex align-items-center">
                <SearchIcon width={20} height={20} className="me-1"/>{" "}
                {t("search results")}
              </h5>

              <div className="flex-grow-1">
                <SearchListingBar inputEl={inputEl}/>
              </div>
            </div>
            {/* <h1 className="h3 m-0 text-capitalize">
          {router.query?.slug?.split("-").join(" ")}
        </h1> */}
          </div>
        </div>

        <div className="row">
          <div className="col-3 col-sm-4 col-lg-3 d-none d-md-block">
            <div className="card py-2">
              <ListingFilter facets={facets} sidebar/>
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-9 d-flex flex-column gap-3">
            {error ? (<div className="text-center">{t("something went wrong")}</div>) : (<>
                {nodes.length === 0 ? (<NoResultListingSearch inputEl={inputEl}></NoResultListingSearch>) : (<div className="d-flex justify-content-between">
                    <div className="d-flex gap-2">
                      <button className="btn px-0 py-0 text-secondary d-md-none" onClick={handleShow}>
                        <i className="bi bi-filter-square-fill fs-5"></i>
                      </button>

                      <Offcanvas backdrop={false} show={show} onHide={handleShow}>
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title></Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <ListingFilter facets={facets} onClose={handleShow}/>
                        </Offcanvas.Body>
                      </Offcanvas>

                      <p className="mb-0">
                        {router.query.page
                    ? `${t("page")} ${router.query.page} ${t("from around")}`
                    : t("around")}{" "}
                        {total || 0} {t("result")}
                      </p>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <Dropdown align="end">
                        <Dropdown.Toggle as={"p"} className="mb-0 text-primary" style={{ cursor: "pointer" }}>
                          {sortOptions.find((option) => option.id === sortBy)
                    ?.label}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {sortOptions.map((option) => (<Dropdown.Item onClick={() => handleSort(option)}>
                              {option.label}
                            </Dropdown.Item>))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>)}

                <div className="row">
                  {nodes.map(function (row, index) {
                return (<div className={`col-6 col-sm-4 mb-4`} key={`listing-${row.id}`}>
                        <ListingItem {...row} photoHeight={"240px"} searchTrackingId={request_id} searchTrackingQuery={search} onClick={() => {
                        handleOnListingClick(row);
                    }} clickCount={clickCount} setClickCount={() => setState({ ...state, countView: clickCount + 1 })}/>
                      </div>);
            })}
                </div>
              </>)}
          </div>
        </div>
      </div>

      <div className="my-3">
        <CustomedPagination totalPage={total_page} currentPage={page || 1} onPaginationLinkClick={onPaginationLinkClick}/>
      </div>
    </div>);
}
async function getServerSideProps(params) {
    const { slug } = params.query;
    const page = params.query.page || 1;
    const category = params.query.property || null;
    const min_price = parseInt(params.query.minPrice) || null;
    const max_price = parseInt(params.query.maxPrice) || null;
    const bedroom = parseInt(params.query.bedroom) || null;
    const bathroom = parseInt(params.query.bathroom) || null;
    const floor = parseInt(params.query.floor) || null;
    const min_build_width = parseFloat(params.query.minBuild) || null;
    const max_build_width = parseFloat(params.query.maxBuild) || null;
    const district_name = params.query.districtName || null;
    const listing_for = parseInt(params.query.type) || null;
    const sort_by = parseInt(params.query.sortBy) || 1;
    const asc = params.query.asc === "true" || false;
    const limit = 30;
    try {
        const splittedSearch = slug.split("-");
        let search = "";
        if (splittedSearch.length > 0 && splittedSearch[1] && splittedSearch[4]) {
            search = splittedSearch[1];
            if (splittedSearch.length > 3) {
                search +=
                    " " + splittedSearch.slice(4, splittedSearch.length).join(" ");
            }
        }
        const client = initializeApollo();
        const { data: { listings }, } = await client.query({
            query: gql `
        query listing {
          listings(
            query: ${search === null ? null : `"${search}"`}
            page: ${page}
            limit: ${limit}
            category: ${category === null ? null : `"${category}"`}
            min_price: ${min_price}
            max_price: ${max_price}
            bedroom: ${bedroom}
            bathroom: ${bathroom}
            floor: ${floor}
            min_build_width: ${min_build_width}
            max_build_width: ${max_build_width}
            listing_for: ${listing_for}
            sort_by: ${sort_by}
            district_name: ${district_name === null ? null : `"${district_name}"`}
            ascending: ${asc}
            ) {
            total
            total_page
            request_id
            nodes{
              ...LandingListing
            }
            facets {
              district_name {
                value
                count
              }
              category {
                value
                count
              }
              listing_for {
                value
                count
              }
            }
          } 
        }
        ${LISTING_FRAGMENT}
      `
        });
        return {
            props: {
                data: { listings }
            }
        };
    }
    catch (error) {
        console.log(error);
        return {
            props: {
                data: {
                    listings: {
                        nodes: []
                    }
                },
                error: true
            }
        };
    }
}

    async function __Next_Translate__getServerSideProps__1967a7f1e58__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/cari/[slug]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1967a7f1e58__ as getServerSideProps }
  